<template>
  <div class="slide zoom" v-parallax-fit="parallax"></div>
</template>

<script>
export default {
  name: 'slide5',
  mounted() {
    const evidence = {
      items: [
        {
          image: '/themes/rise-theme/dist/images/estate/character-view/vanessa/evidence/3.jpg',
          url: 'https://www.brookings.edu/blog/up-front/2019/02/13/renting-the-american-dream-why-homeownership-shouldnt-be-a-pre-requisite-for-middle-class-financial-security/',
          link_title: {
			'en': 'Renting the American Dream',
			'es': 'Alquilar el sueño americano'
		  },
        },
      ],
      text: {
		'en': '"Housing policy in the U.S. tilts the playing field in favor of homeownership...Federal tax policy gives special preferences to owner-occupied housing, through the mortgage interest deduction and capital gains exclusion. Political rhetoric ... reinforces the idea that renting a home should be seen as a temporary state, a waystation on the journey to the final destination of homeownership."<br /><b>From: Renting the American Dream: Why homeownership shouldn’t be a prerequisite for middle-class financial security by Jenny Schuetz, The Brooking Institution, Wednesday, February 13, 2019</b>',
		'es': '"La política de vivienda en los EE. UU. inclina el campo de juego a favor de la propiedad de la vivienda... La política fiscal federal otorga preferencias especiales a las viviendas ocupadas por sus propietarios, a través de la deducción de intereses hipotecarios y la exclusión de las ganancias de capital. La retórica política... refuerza la idea de que alquilar una el hogar debe verse como un estado temporal, una estación de paso en el viaje hacia el destino final de ser propietario de una vivienda".<br /><b>De: Alquilar el sueño americano: por qué ser propietario de una vivienda no debería ser un requisito previo para la seguridad financiera de la clase media por Jenny Schuetz, The Brooking Institution, miércoles 13 de febrero de 2019</b>'
	  }
    };

    const text = {
		'en': 'Homeownership isn\'t inherently more stable than renting and does carry its own risks. While policymakers of both political parties have propped up homeownership as an ultimate goal, the real need for Americans is stable, decent housing in a safe, healthy community - and more ways to build wealth that don\'t just depend on ownership.',
		'es': 'Ser propietario de una vivienda no es intrínsecamente más estable que alquilar y conlleva sus propios riesgos. Si bien los formuladores de políticas de ambos partidos políticos han apoyado la propiedad de la vivienda como objetivo final, la verdadera necesidad de los estadounidenses es una vivienda estable y decente en una comunidad segura y saludable, y más formas de generar riqueza que no dependan solo de la propiedad.'
	};
    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach( mutation => {
        if(mutation.target.style.transform == 'translateY(600px)') {
          this.$evidence.value = JSON.stringify(evidence);
          this.$readMore.value = text;
        }
      });
    });

    this.mutationObserver.observe(document.querySelector('#slide5'), {
      attributes: true,
      attributeFilter: ['style']
    });
  },
  unmounted() {
    this.mutationObserver.disconnect();
  },
  data() {
    return {
		mutationObserver: null,
      parallax: [
        {
          start: 3000,
          end: 3500,
          fromStyle: { transform: 'translateY(-500px)' },
          toStyle: { transform: 'translateY(600px)' },
          easing: 'linear'
        },
        {
          start: 4200,
          end: 4800,
          fromStyle: { transform: 'translateY(601px)' },
          toStyle: { transform: 'translateY(2500px)' },
          easing: 'linear'
        }
      ]
    };
  }
}
</script>

<style lang="scss" scoped>
.slide {
    position: absolute;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/05_Photo.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 470px;
    height: 550px;
    left: -233px;
    top: -40%;
    transition: 0.3s;

    @media(max-width: 600px) {
      width: 200px;
      left: -100px;
    }
    @media(max-width: 400px) {
      top: -570px;
    }
}
</style>
